import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Layout extends React.PureComponent {
    state = {
        allList: this.props.content?.pageData?.list || [],
        filterList: this.props.content?.pageData?.list || [],
        isSearch: false,
        inputText: '',
        bref: this.props.content?.pageData?.desc || '',
        hasShadow: false,
    };

    returnList = () => {
        const { allList } = this.state;

        this.setState({
            filterList: allList,
            inputText: '',
            isSearch: false,
        });
    };

    searchHandle = () => {
        const { inputText, allList } = this.state;
        const filterList = [];

        if (inputText.trim() !== '') {
            allList.map((item) => {
                if (item?.company?.toString?.()?.toLocaleLowerCase?.()?.includes?.(inputText.toLocaleLowerCase())) {
                    filterList.push(item);
                }

                return item;
            });
        }

        this.setState({
            filterList,
            isSearch: true,
        });
    };

    changeInput = (event) => {
        const { allList } = this.state;

        if (event.target.value !== '') {
            this.setState({
                inputText: event.target.value,
            });
        } else {
            this.setState({
                isSearch: false,
                inputText: '',
                filterList: allList,
            });
        }
    };

    render() {
        const { filterList, bref, isSearch, inputText, hasShadow } = this.state;

        return (
            <div className={styles.layout}>
                <div className={styles.bref}>{bref}</div>
                <div className={styles.search}>
                    <div
                        className={`${styles.searchBox} ${hasShadow ? styles.searchBoxShadow : ''}`}
                        ref={this.searchRef}>
                        <div className={styles.searchInput}>
                            <input
                                type="text"
                                onChange={this.changeInput}
                                value={inputText}
                                placeholder="搜索品牌名称"
                            />
                        </div>
                        <div onClick={this.searchHandle} className={styles.searchIcon}>
                            {/* 搜索 */}
                        </div>
                        {isSearch && (
                            <div onClick={this.returnList} className={styles.rankButton}>
                                榜单
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.tableBox}>
                    <table cellPadding="0" cellSpacing="0" className={styles.tableList}>
                        <thead>
                            <tr>
                                <th>2023年排名</th>
                                <th>2022年排名</th>
                                <th>品牌</th>
                                <th>2023年度品牌价值（美元，亿）</th>
                                <th>2023年度评级</th>
                                <th>2022年度评级</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filterList.slice(0, 500).length > 0 ? (
                                filterList.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{item.rank23}</td>
                                            <td>{item.rank22}</td>
                                            <td>{item.company}</td>
                                            {item.rank23 < 101 ? (
                                                <td>{item.country}</td>
                                            ) : (
                                                <td colSpan={3}>非公开信息</td>
                                            )}
                                            {item.rank23 < 101 && (
                                                <>
                                                    <td>{item.market23}</td>
                                                    <td>{item.market22}</td>
                                                </>
                                            )}
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr className={styles.searchInfo}>
                                    <td colSpan="6">
                                        {inputText ? '您搜索的品牌没有进入榜单' : '抱歉，请您输入品牌名称后再进行搜索'}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
